export const getConfigValue = (key: string) => {
  const configs = JSON.parse(localStorage.getItem("configs") ?? "[]");
  return configs.find((item: any) => item.key === key)?.value;
};
